import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { takeUntil, take } from 'rxjs/operators';
import { CallComponent } from "../call/call.component";
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { DeskState } from '../../models/deskstate.model';
import { DeskStateService } from '../../services/desk-state.service';
import { ChatService } from '../../services/chat.service';
import { BusinessEventService } from '../../services/business-event.service';

@Component({
  selector: 'app-stop-desk',
  templateUrl: './stopdesk.component.html',
  styleUrls: ['./stopdesk.component.css']
})
export class StopdeskComponent implements OnInit {

  private subscriptionClose: Subscription;
  private subscriptionOpen: Subscription;
  private loadingSocket: boolean = false;

  @Input() inline: boolean = false;
  @ViewChild(CallComponent) callComponent: CallComponent;

  private destroy$ = new Subject();

  constructor(public _data: DataService,
    private _deskState: DeskStateService,
    private _bevent: BusinessEventService,
    private _chat: ChatService,
    private _blogic: BusinesLogicService) { }

  ngOnInit() {
    this._loadDeskState();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  stop() {
    this._bevent.close();
    this._chat.close();
    this._data.deskStopped = true;
    this._saveDeskState();

    this._blogic
      .stop()
      .pipe(take(1))
      .subscribe();
  }

  ready() {
    this.InitSocketCom();
    this._data.deskStopped = false;
    this._saveDeskState();

    this._blogic
      .ready()
      .pipe(take(1))
      .subscribe();
  }

  private InitSocketCom() {
    if (!this.loadingSocket) {
      this.loadingSocket = true;
      if (this.subscriptionClose != null)
        this.subscriptionClose.unsubscribe();
      if (this.subscriptionOpen != null)
        this.subscriptionOpen.unsubscribe();
      this._bevent.close();

      this._bevent.open();

      this.subscriptionOpen = this._bevent.onOpen()
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.loadingSocket = false;
        });

      this.subscriptionClose = this._bevent.onClose()
        .pipe(takeUntil(this.destroy$))
        .subscribe();
    }

  }

  private _saveDeskState() {
    const state = {
      deskStopped: this._data.deskStopped,
    };
    this._deskState.saveState(state);
  }

  private _loadDeskState() {
    const savedState = this._deskState.loadState() as DeskState;
    if (savedState) {
      this._data.deskStopped = savedState.deskStopped || false;
    }
  }

}
